export const IconExport = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
			<path
				fill="currentColor"
				d="M3,12 L3,16 C3,16.5203785 3.54813882,17 4.28571429,17 L15.7142857,17 C16.4518612,17 17,16.5203785 17,16 L17,12 L19,12 L19,16 C19,17.6887605 17.5014405,19 15.7142857,19 L4.28571429,19 C2.49855946,19 1,17.6887605 1,16 L1,12 L3,12 Z M10,0.585786438 L10.7071068,1.29289322 L14.4571068,5.04289322 L13.0428932,6.45710678 L11,4.41578644 L11,14 L9,14 L9,4.41378644 L6.95710678,6.45710678 L5.54289322,5.04289322 L10,0.585786438 Z"
			/>
		</svg>
	);
};
